import baseApi from "../utils/ApiUtils";

export const mastersApi = (resource, method, payload = null, params = null, id = null) => {
  const url = id ? `/masters/${resource}/${id}/` : `/masters/${resource}/`;
  return baseApi(url, method, params, payload).then((response) => response.data);
};
